import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from './Roundel.module.scss'

export const MailRoundelIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 32,
  height = 32,
  className,
  ...rest
}) => {
  return (
    <Icon
      className={classnames(styles.mail, className)}
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <path
        d="M27,10 L27,21 C27,22.33 26.33,23 25,23 L7,23 C5.67,23 5,22.33 5,21 L5,10 C5,9.69 5.04,9.41 5.11,9.17 L14.18,16.88 L14.31,17.01 C14.67,17.32 15.07,17.5 15.5,17.5 C15.98,17.5 16.43,17.27 16.85,16.85 L26.58,8.59 C26.86,8.92 27,9.39 27,10 Z M25,8 C25.24,8 25.46,8.02 25.65,8.06 L16.18,16.12 L16.08,16.22 C15.85,16.42 15.66,16.5 15.5,16.5 C15.31,16.5 15.1,16.4 14.85,16.15 L5.68,8.35 C6,8.12 6.44,8 7,8 L25,8 Z"
        data-testid="roundel-icon-mail"
        fill="#ffffff"
        className={styles.white}
      />
    </Icon>
  )
}
